export const invoiceNonComissionTags = ['InvoiceNonComission'];
export const AIRTICKET_NON_COMISSION_LIST = 'AIRTICKET_NON_COMISSION_LIST';
